import React from "react"
import { useState } from "react"
import { Checkbox, Form, Table } from "semantic-ui-react"
import NumericInput from "../../components/shared/NumericInput"
import TextInput from "../../components/shared/TextInput"
import { GetFullName, useLoader } from "../../components/shared/utils"
import { useTextResources } from "../../language"
import ReservationSummary from "../../components/ReservationSummary";
import ColorPicker from "../../components/shared/ColorPicker"
import CheckboxWrapper from "../../components/shared/Checkbox"
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import mockReservations from '../../mock/Reservation/reservation-hotel-optima3530.json'
import { useEffect } from "react"
import { onError, onSuccess } from "../../components/shared/messages"
import { MenuActions } from "../../components/shared/constants"
import { useMemo } from "react"
import SearchPanel from "../../components/SearchPanel"
import FitReservation from "../GroupReservation/FitTab/fit"
import moment from 'moment'
import { useCallback } from "react"
import { actions } from "../GroupReservation/context"
import { resStates } from "../GroupReservation/consts"


export const FamilyAndFriendsPage = () => {
  const reservation = mockReservations[0]
  const reservationSelectedRoom = 
  {
    roomId: reservation.RoomId,
    startDate: reservation.CheckInDate,
    endDate: reservation.CheckOutDate,
    key: -1
  }
  const text = useTextResources()
  const [reservations, setReservations] = useState([])
  const [selectedRooms, setSelectedRooms] = useState([reservationSelectedRoom])
  const loader = useLoader()
  const [errors, setErrors] = useState({})
  
  

  console.log(setErrors)

  const save = () => {
    (async () => {
      try {
        loader(true)

        onSuccess()
      } catch (error) {
        onError(error)
      } finally {
        loader(false)
      }
    })()
  }

  useEffect(() => {
    if (window.optima.commands) {
      window.optima.commands.unsubscribe(MenuActions.save);
      window.optima.commands.subscribe(MenuActions.save, save);
    }
  }, [save]);

  const searchOptions = useMemo(() => {
    return {
      fields: [
        <Form.Field control={NumericInput} label={text("NumberOfRooms")} key="NumberOfRooms" digits={0} min={1} max={100} />,
        <Form.Field width={3} control={TextInput} label={text("GroupName")} key="GroupName" />,
        <Form.Field control={ColorPicker} label={text("Color")} key="Color" type="Slider" />,
        <CheckboxWrapper width={3} label={text("RouteChargesToMainReservation")} key="RouteCharges" />
      ],
      buttonText: text("Create"),
      initial: {
        NumberOfRooms: 1,
        GroupName: `${GetFullName(reservation.Guest)}'s Group`
      },
      customSearch: state => {
        const reservations = []
        for (var i = 0; i < state.NumberOfRooms; i++) {
          const created = {
            ...reservation,
            Id: null,
            Number: null,
            RoomId: null
          }
          reservations.push({State: resStates.new, Reservation:created})
        }
        setReservations(reservations)
        setSelectedRooms([reservationSelectedRoom])
      }
    }
  }, [reservation])

  const filterRooms = useCallback((rooms, currentValue, fit) => {
    const retval = rooms.filter(room => {
      //This code check if room already assigned by room id and overlapping dates
      const alreadyAssigned = selectedRooms.some(r => {
        let startDate1 = moment(r.startDate)
        let endDate1 = r.startDate === r.endDate ? moment(r.endDate) : moment(r.endDate).add(-1, 'days')
        let startDate2 = moment(fit.CheckInDate)
        let endDate2 = fit.CheckInDate === fit.CheckOutDate ? moment(fit.CheckOutDate) : moment(fit.CheckOutDate).add(-1, 'days')
        return (
          r.roomId === room.value &&
          ((startDate1.startOf('day') <= endDate2.startOf('day')) && (startDate2.startOf('day') <= endDate1.startOf('day')))
        )
      })
      return !alreadyAssigned || currentValue === room.value
    })
    return retval
  }, [selectedRooms, reservation])

  const onSelectRoom = (res, value, key) => {
    let keyExists = selectedRooms.find(s => s.key === key)
    // If fit already exists in selectedRooms list so update record, otherwise add new record to selectedRooms list
    if (keyExists) {
      keyExists.roomId = value
      setSelectedRooms([
        ...selectedRooms
      ])
    }
    else {
      setSelectedRooms([
        ...selectedRooms,
        {
          roomId: value,
          startDate: res.CheckInDate,
          endDate: res.CheckOutDate,
          key: key
        }
      ])
    }
  }
  const selectAllReservations = (checked) => {

    setReservations(reservations.map(reservation => {
      return { ...reservation, IsSelected: checked }
    }))
  }

  const onUpdateReservations = ({ type }) => {
    if (type === actions.update) {
      setReservations([...reservations])
    }
  }

  return <div style={{ display: "flex", flexDirection: "row", flex: 1 }} className="family">
    <div style={{ width: 350, marginRight: "1em" }}><ReservationSummary reservation={reservation} readOnly Currency={reservation.CurrencyId} groupReservations={reservations} /></div>
    <div style={{ flex: 1 }}>
      <div style={{ marginBottom: "1em" }}>
        <SearchPanel options={searchOptions} />
      </div>
      <div style={{ flex: 1 }}>
        <Table celled size="small">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell style={{ width: "1em" }}><Checkbox onChange={(e, { checked }) => selectAllReservations(checked)} checked={!reservations.some(r => !r.IsSelected)} /></Table.HeaderCell>
              <Table.HeaderCell>{text("Number")}</Table.HeaderCell>
              <Table.HeaderCell width="2">{text("Arrival")} - {text("Departure")}</Table.HeaderCell>
              <Table.HeaderCell width="3">{text("Guest")}</Table.HeaderCell>
              <Table.HeaderCell width="1">{text("Adults")}</Table.HeaderCell>
              <Table.HeaderCell width="1">{text("Children")}</Table.HeaderCell>
              <Table.HeaderCell width="1">{text("Infants")}</Table.HeaderCell>
              <Table.HeaderCell width="2">{text("RoomType")}</Table.HeaderCell>
              <Table.HeaderCell width="2">{text("Room")}</Table.HeaderCell>
              <Table.HeaderCell width="1">{text("PriceBeforeTax")}</Table.HeaderCell>
              <Table.HeaderCell width="1">{text("PriceAfterTax")}</Table.HeaderCell>
              <Table.HeaderCell style={{ width: "1em" }}></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              reservations.map((reservation, index) => {
                const key = reservation.Id || index
                return <FitReservation fit={reservation} filter={filterRooms} key={key} rowKey={key} onSelectRoom={onSelectRoom} errors={errors[key]} onUpdate={onUpdateReservations} />
              })
            }
          </Table.Body>
        </Table>
      </div>
    </div>
  </div>
}